export const copConstants = {
    SEARCH_CRIMINAL_REQUEST: "SEARCH_CRIMINAL_REQUEST",
    SEARCH_CRIMINAL_SUCCESS: "SEARCH_CRIMINAL_SUCCESS",
    SEARCH_CRIMINAL_FAIL: "SEARCH_CRIMINAL_FAIL",

    SEARCH_CRIMINAL_RESET: "SEARCH_CRIMINAL_RESET",

    CLEAR_ERRORS: "CLEAR_ERRORS"
}